module.exports = __webpack_public_path__ + "img/epr_medium.9cd03a4e.jpg";